// src/components/tabs/TransactionsTab.jsx
import React from 'react';
import { CreditCard, Link as LinkIcon } from 'lucide-react';
import Hero from '../shared/Hero';

const TransactionsTab = ({ transactions, formatCurrency }) => {
  return (
    <div>
      {/* Hero institucional */}
      <Hero
        title="Transações Bancárias"
        subtitle="Millennium BCP • Conta 1234"
        icons={['/icons/globe.png']}
      />

      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-blue-600" />
            Bank Transactions
          </h3>
          <p className="text-gray-600 text-sm mt-1">Recent transactions from your bank account</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Match Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {transactions.map((transaction) => (
                <tr
                  key={transaction.id}
                  className={`hover:bg-gray-50 transition-colors ${
                    transaction.matching_status === 'matched' ? 'bg-green-50' : ''
                  }`}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {transaction.booking_date}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 max-w-xs">
                    <div className="truncate" title={transaction.remittance_information}>
                      {transaction.remittance_information}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`text-sm font-medium ${
                        transaction.transaction_amount > 0 ? 'text-green-600' : 'text-red-600'
                      }`}
                    >
                      {formatCurrency(transaction.transaction_amount, transaction.currency)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                        transaction.transaction_amount > 0
                          ? 'bg-green-100 text-green-700'
                          : 'bg-red-100 text-red-700'
                      }`}
                    >
                      {transaction.transaction_amount > 0 ? 'Credit' : 'Debit'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {transaction.matched_invoice_id ? (
                      <div className="flex items-center gap-2">
                        <LinkIcon className="w-4 h-4 text-green-600" />
                        <span className="text-xs text-green-700 font-medium">
                          Matched{' '}
                          {transaction.matching_confidence
                            ? `(${transaction.matching_confidence}%)`
                            : ''}
                        </span>
                      </div>
                    ) : (
                      <span className="inline-flex px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
                        Unmatched
                      </span>
                    )}
                  </td>
                </tr>
              ))}

              {transactions.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                    Nenhuma transação encontrada.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TransactionsTab;
